// **************************************************
// Hardness Info Content Toggle
// **************************************************


const hardnessTitles = document.querySelectorAll('.hardness-info__content-title');

hardnessTitles.forEach((hardnessTitle) => {
  const hardnessItem = hardnessTitle.closest('.hardness-info__content-item');
  const hardnessContent = hardnessItem.querySelector('.hardness-info__content-text');

  // Toggle Class And Slide Toggle On Click
  hardnessTitle.addEventListener('click', () => {
    if (windowWidth() < breakpointMd) {
      hardnessItem.classList.toggle('is-open');
      slideToggle(hardnessContent, 300, 'block');
    }
  });
});

